<div class="w-full px-2 lg:px-4 bg-white rounded-lg py-2 mt-2">
  <div class="sm:flex items-center justify-between gap-2">
    <p class="text-0d5bab font-bold text-[13px] sm:text-sm lg:text-base xl:text-lg capitalize mb-2 sm:mb-0">Trail
      Balance</p>
    <div class="flex flex-wrap items-center justify-start gap-2">
      <!-- all firms -->
      <select [(ngModel)]="selectedFirmId" (change)="onFilterChange()"
        class="cursor-pointer bg-white border border-d9d9d9 rounded-md ps-1 2xl:ps-2 pe-7 py-2 text-[13px] text-383838">
        <option *ngIf="firms.length > 1" value="">All Firms</option>
        <option *ngFor="let firm of firms" [value]="firm.id">
          {{ firm.name }}
        </option>
      </select>
      <!-- Date From -->
      <div class="relative">
        <input type="date" [(ngModel)]="fromDate" (change)="onFilterChange()"
          class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner">
        <label
          class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">From</label>
      </div>
      <!-- Date To -->
      <div class="relative">
        <input type="date" [(ngModel)]="toDate" (change)="onFilterChange()"
          class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner">
        <label
          class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">To</label>
      </div>
      <!-- Export Button -->
      <button (click)="exportToExcel()"
        class="cursor-pointer capitalize rounded-md border border-898989 bg-white text-898989 text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center">Export</button>
      <!-- Print Button -->
      <button (click)="printTrialBalance()"
        class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center">Print</button>
    </div>
  </div>

  <!-- Rows and Search -->
  <div class="flex flex-col md:flex-row justify-between items-center mt-6 mb-4 gap-4">
    <div class="flex items-center gap-4 w-full md:w-auto">
      <div class="flex items-center gap-2">
        <label class="text-[13px] font-medium text-383838">Rows:</label>
        <select [(ngModel)]="itemsPerPage" (change)="onSearchChange()"
          class="border border-d9d9d9 rounded-md px-2 py-1 text-[13px] focus:outline-none focus:border-c19725 bg-white">
          <option *ngFor="let count of [5, 10, 20, 50, 100]" [value]="count">{{ count }}</option>
        </select>
      </div>
      <div class="flex items-center gap-2 flex-grow md:flex-grow-0">
        <label class="text-[13px] font-medium text-383838">Search:</label>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" placeholder="Search accounts..."
          class="border border-d9d9d9 rounded-md px-3 py-1 text-[13px] w-full md:w-64 focus:outline-none focus:border-c19725" />
      </div>
    </div>
    <div class="text-[12px] text-gray-500 italic" *ngIf="trialBalance.length > 0">
      Showing {{ (p - 1) * itemsPerPage + 1 }} to {{ p * itemsPerPage > trialBalance.length ? trialBalance.length : p *
      itemsPerPage }} of {{ trialBalance.length }} accounts
    </div>
  </div>

  <!-- Tab Section (Only for Non-GST firms) -->
  <div *ngIf="isNonGst" class="flex gap-4 mt-4 mb-2 border-b border-gray-100 bg-white">
    <button (click)="switchTab('cash')"
      [class]="activeTab === 'cash' ? 'px-6 py-2 border-b-2 border-blue-600 text-blue-600 font-bold text-[13px] transition-all' : 'px-6 py-2 text-gray-400 font-bold text-[13px] hover:text-gray-600 transition-all'">
      Cash Accounts (₹)
    </button>
    <button (click)="switchTab('metal')"
      [class]="activeTab === 'metal' ? 'px-6 py-2 border-b-2 border-amber-600 text-amber-600 font-bold text-[13px] transition-all' : 'px-6 py-2 text-gray-400 font-bold text-[13px] hover:text-gray-600 transition-all'">
      Metal Accounts (gm)
    </button>
  </div>

  <div class="overflow-x-auto w-full mt-4 space-y-2">
    <table class="listtable2 bg-white w-full border border-gray-200">
      <thead class="bg-ecf6ff5c rounded-lg border-b border-0d5bab">
        <tr>
          <th
            class="text-left text-0d5bab font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5 whitespace-nowrap">
            Account Details {{ isNonGst ? (activeTab === 'metal' ? ' (gm)' : ' (₹)') : '' }}
          </th>
          <th
            class="text-right text-0d5bab font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5 whitespace-nowrap">
            Opening Balance
          </th>
          <th
            class="text-right text-0d5bab font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5 whitespace-nowrap">
            Debit Amount
          </th>
          <th
            class="text-right text-0d5bab font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5 whitespace-nowrap">
            Credit Amount</th>
          <th
            class="text-right text-0d5bab font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5 whitespace-nowrap">
            Closing Balance
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of paginatedTrialBalance; trackBy: trackByAccount"
          class="hover:bg-gray-50 transition-colors">
          <!-- Account -->
          <td class="text-left text-2c2c2c font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5">
            {{ row.account }}
          </td>

          <!-- Opening Balance -->
          <td class="text-right font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5"
            [ngClass]="row.openingType === 'CR' ? 'text-green-600' : 'text-red-600'">
            {{ row.openingAmount | number:'1.2-2' }} {{ row.openingType }}
          </td>

          <!-- Debit -->
          <td class="text-right text-2c2c2c font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5">
            {{ row.debit | number:'1.2-2' }}
          </td>

          <!-- Credit -->
          <td class="text-right text-2c2c2c font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5">
            {{ row.credit | number:'1.2-2' }}
          </td>

          <!-- Closing Balance -->
          <td class="text-right font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-1.5"
            [ngClass]="getClosing(row).type === 'CR' ? 'text-green-600' : 'text-red-600'">
            {{ getClosing(row).amount | number:(isNonGst && activeTab === 'metal' ? '1.3-3' : '1.2-2') }} {{
            getClosing(row).type }}
          </td>

        </tr>

        <!-- Empty State -->
        <tr *ngIf="trialBalance.length === 0">
          <td colspan="5" class="text-center py-4 text-gray-500">
            No Data Available
          </td>
        </tr>
      </tbody>
      <tfoot class="bg-f9e576ad border-t border-c9ab04">
        <tr>
          <td class="text-left text-010101 font-semibold text-sm sm:text-base lg:text-lg px-1.5 py-1.5">Total</td>
          <td class="text-right font-semibold text-sm sm:text-base lg:text-lg px-1.5 py-1.5"
            [ngClass]="getTotalOpening().type === 'CR' ? 'text-green-600' : 'text-red-600'">
            {{ getTotalOpening().amount | number:(isNonGst && activeTab === 'metal' ? '1.3-3' : '1.2-2') }} {{
            getTotalOpening().type }}
          </td>
          <td class="text-right text-010101 font-semibold text-sm sm:text-base lg:text-lg px-1.5 py-1.5">{{
            getTotalDebit() | number:(isNonGst && activeTab === 'metal' ? '1.3-3' : '1.2-2') }}</td>
          <td class="text-right text-010101 font-semibold text-sm sm:text-base lg:text-lg px-1.5 py-1.5">{{
            getTotalCredit() | number:(isNonGst && activeTab === 'metal' ? '1.3-3' : '1.2-2') }}</td>
          <td class="text-right text-010101 font-semibold text-sm sm:text-base lg:text-lg px-1.5 py-1.5"
            [ngClass]="getTotalClosing().type === 'CR' ? 'text-green-600' : 'text-red-600'">
            {{ getTotalClosing().amount | number:(isNonGst && activeTab === 'metal' ? '1.3-3' : '1.2-2') }} {{
            getTotalClosing().type }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- Pagination Controls -->
  <div *ngIf="totalPages > 1" class="flex items-center justify-center mt-6 gap-2 pb-4">
    <button (click)="goToPreviousPage()" [disabled]="p === 1"
      class="inline-flex items-center justify-center w-8 h-8 rounded-md text-c19725 border border-c19725 hover:bg-[#f6f1cb] disabled:opacity-30 disabled:pointer-events-none transition-all">
      <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          clip-rule="evenodd" />
      </svg>
    </button>

    <div class="flex gap-2">
      <ng-container *ngFor="let page of pageNumbers">
        <button *ngIf="page !== '...'; else ellipsis" (click)="onPageChange(+page)" [class.bg-c19725]="p === page"
          [class.text-white]="p === page"
          class="inline-flex items-center justify-center min-w-[32px] h-8 rounded-md text-sm font-bold text-c19725 border border-c19725 hover:bg-[#f6f1cb] transition-all">
          {{ page }}
        </button>
        <ng-template #ellipsis>
          <span class="inline-flex items-center justify-center w-8 h-8 text-sm font-normal text-gray-400">...</span>
        </ng-template>
      </ng-container>
    </div>

    <button (click)="goToNextPage()" [disabled]="p === totalPages"
      class="inline-flex items-center justify-center w-8 h-8 rounded-md text-c19725 border border-c19725 hover:bg-[#f6f1cb] disabled:opacity-30 disabled:pointer-events-none transition-all">
      <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</div>